
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all(/*  | __federation_expose_App */ [__webpack_require__.e("3504"), __webpack_require__.e("1091"), __webpack_require__.e("7150"), __webpack_require__.e("6362")]).then(() => (() => (__webpack_require__(73935))));
},
"./AgentStudio": () => {
return Promise.all(/*  | __federation_expose_AgentStudio */ [__webpack_require__.e("3504"), __webpack_require__.e("7150")]).then(() => (() => (__webpack_require__(40989))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };